import { render, staticRenderFns } from "./DisplayUnderReview.vue?vue&type=template&id=2bb7e335"
import script from "./DisplayUnderReview.vue?vue&type=script&lang=js"
export * from "./DisplayUnderReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports